import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import eye from '../../assest/images/eye.png';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import CustomDropdown from '../common/CustomDropdown';
import Icon3 from '../../assest/images//Icon3.png';

const ShipmentApprovalList = () => {
  //const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode } = useParams();
  const [shipmentData, setShipmentData] = useState([]);
  const [selection, setSelection] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Set the number of items per page
  const [firstFilter, setFirstFilter] = useState('');
  const [firstFilterSearch, setFirstFilterSearch] = useState('');
  const [secondFilter, setSecondFilter] = useState('');
  const [secondFilterSearch, setSecondFilterSearch] = useState('');


  const [firstFilterOptions, setFirstFilterOptions] = useState([]);
  const [secondFilterOptions, setSecondFilterOptions] = useState([]);

  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);


  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const updateFilterOptions = (selection) => {
    const commonOptions = [
      { value: 'LGCM_Name', label: 'Logistic Party Name', disabled: false },
      { value: 'LGCVM_VehicleNumber', label: 'Vehicle Number', disabled: false },
      { value: 'StatusDescription', label: 'Status', disabled: false }
    ];

    const newOrderOptions = [
      { value: 'SHPH_ShipmentCode', label: 'Shipment Code', disabled: false }
    ];

    const returnShipmentOptions = [
      { value: 'SHPR_ShipmentReturnCode', label: 'Shipment Code', disabled: false }
    ];

    setFirstFilterOptions([
      ...commonOptions,
      ...(selection === 'New Order' ? newOrderOptions : []),
      ...(selection === 'Return Shipment' ? returnShipmentOptions : [])
    ]);

    setSecondFilterOptions([
      ...commonOptions,
      ...(selection === 'New Order' ? newOrderOptions : []),
      ...(selection === 'Return Shipment' ? returnShipmentOptions : [])
    ]);
  };

  const fetchShipmentData = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      setShipmentData(data.shipmentData);
    } catch (err) {
      console.error('Error fetching shipment data:', err);
    }
  };

  useEffect(() => {
    // Whenever any of the filters change, reset to the first page
    setCurrentPage(1);
  }, [firstFilterSearch, secondFilterSearch]);

  useEffect(() => {
    const selection = sessionStorage.getItem('selection');
    console.log("selection", selection);
    if (selection) {
      setSelection(selection);
      updateFilterOptions(selection);
    }
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelection(value);
    sessionStorage.setItem('selection', value);
    setFirstFilter("");
    setFirstFilterSearch("");
    setSecondFilter("");
    setSecondFilterSearch("");
    updateFilterOptions(value);
  };

  useEffect(() => {
    if (selection) {
      const url = selection === 'New Order'
        ? `${config.API_URL}/shipment/approve/${selectedScpId}`
        : `${config.API_URL}/returnshipment/approve/${selectedScpId}`;
      fetchShipmentData(url);
    }
  }, [selectedScpId, selection]);

  const handleFirstFilterChange = (event) => {
    const value = event.target.value;
    setFirstFilter(value);
    setFirstFilterSearch('');

    const updatedSecondOptions = secondFilterOptions.map(option => ({
      ...option,
      disabled: option.value === value
    }));
    setSecondFilterOptions(updatedSecondOptions);
  };

  const handleSecondFilterChange = (event) => {
    const value = event.target.value;
    setSecondFilter(value);
    setSecondFilterSearch('');
    const updatedFirstOptions = firstFilterOptions.map(option => ({
      ...option,
      disabled: option.value === value
    }));
    setFirstFilterOptions(updatedFirstOptions);
  };

  const filteredListData = shipmentData.filter(item => {
    const firstFilterValue = item[firstFilter];
    const secondFilterValue = item[secondFilter];

    const matchesFirstFilter =
      (firstFilter !== 'GRPM_GroupStatus' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));

    const matchesSecondFilter =
      (secondFilter !== 'GRPM_GroupStatus' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));

    return matchesFirstFilter && matchesSecondFilter;
  });

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);

  // Define options as objects
  const options = [
    { id: 'New Order', name: 'New Order' },
    { id: 'Return Shipment', name: 'Return Shipment' },
  ];
  return (
    <>
      <div className="main_container">
        <h3 className="formHeading">Shipment Approval</h3>

        <label className='form-label' style={{ marginTop: '10px' }} >Shipment Type</label>
        <div className='select-container col-md-5 mb-3'>
          <CustomDropdown
            name="selection"
            options={options}
            value={selection}
            onChange={handleChange}
            placeholder="--Select--"
            idKey="id"
            displayKey="name"

          />
        </div>
        {selection && (
          <>

            <div className="filter-container">
              <div className='select-container_list'>
                <CustomDropdown
                  options={firstFilterOptions}
                  value={firstFilter}
                  onChange={handleFirstFilterChange}
                  name="firstFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />

              </div>
              <input className='search-input' type="text" value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />

              <div className='select-container_list'>
                <CustomDropdown
                  options={secondFilterOptions}
                  value={secondFilter}
                  onChange={handleSecondFilterChange}
                  name="secondFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />

              </div>
              <input className='search-input' type="text" value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder={`Search`} />

            </div>
          </>
        )}

        {selection && (
          <>
            <div className="ptable-wrapper">
              <table className="ptableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Logistic Party Name</th>
                    <th>Vehicle Number</th>
                    <th>Status</th>
                    <th>Shipment Code</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {selection && (
                  filteredListData.length === 0 ? (
                    <tbody >
                      <tr>
                        <td colSpan="9">No Records Found</td> {/* Set colSpan to match the number of columns */}
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {currentItems.map((shipment, index) => {
                        const shipmentCode = selection === 'New Order' ? shipment.SHPH_ShipmentCode : shipment.SHPR_ShipmentReturnCode;
                        const link = selection === 'New Order'
                          ? `/shipmentoutwardapproval/${shipmentCode}`
                          : `/shipmentreturnapproval/${shipmentCode}`;
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{shipment.LGCM_Name}</td>
                            <td>{shipment.LGCVM_VehicleNumber || "N/A"}</td>
                            <td>{shipment.StatusDescription}</td>
                            <td>{shipmentCode}</td>
                            <td>
                              <Link to={link}>
                                <img title='Edit' src={Icon3} alt="Edit" />
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )
                )}
              </table>
            </div>
          </>
        )}
      </div>
      <ul className="pagination">
        {/* First Page Button */}
        <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(1)}>First</button>
        </li>

        {/* Previous Page Button */}
        <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
        </li>

        {/* Page Numbers */}
        {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
          <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
          </li>
        ))}

        {/* Next Page Button */}
        <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
        </li>

        {/* Last Page Button */}
        <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
          <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
        </li>
      </ul>

    </>
  );
};

export default ShipmentApprovalList;
